import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Lock, ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("whipitup_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-charcoal flex items-center justify-center px-6 py-24 relative overflow-hidden">
      <div
        className="absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full opacity-[0.14] blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #D89999 0%, transparent 60%)" }}
      />
      <div className="relative w-full max-w-md">
        <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-3 text-center">// ADMIN AREA</p>
        <h1 className="font-serif-display italic text-5xl md:text-6xl text-off-white text-center leading-[0.95]">Sign in.</h1>
        <p className="mt-4 text-off-white/60 font-light text-center">Whip It Up backoffice — orders, fulfillment, revenue.</p>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] text-off-white/60 flex items-center gap-2 mb-2">
              <Lock size={12} className="text-rose" /> ADMIN PASSWORD
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              required
              className="w-full h-12 bg-off-white/[0.04] border border-off-white/20 focus:border-rose outline-none px-4 text-off-white font-mono tracking-widest transition-colors-only"
            />
          </div>

          {error && (
            <p className="font-mono text-[11px] tracking-[0.2em] text-rose-deep">// {error.toUpperCase()}</p>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className="w-full h-14 bg-rose text-charcoal font-mono text-[12px] tracking-[0.25em] font-semibold flex items-center justify-center gap-2 hover:bg-off-white transition-colors-only disabled:opacity-60"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> AUTHENTICATING…</> : <>SIGN IN <ArrowRight size={16} /></>}
          </button>
        </form>

        <Link to="/" className="block mt-8 text-center font-mono text-[10px] tracking-[0.3em] text-off-white/50 hover:text-rose transition-colors-only">
          ← BACK TO STORE
        </Link>
      </div>
    </main>
  );
};

export default AdminLogin;
